import PropTypes from "prop-types";
import styled from "styled-components";

import { useGoogleMaps } from "../../contexts/GoogleMapsContext";

const Fallback = styled.div`
  min-height: ${(props) => props.$height};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  padding: 20px;
  box-sizing: border-box;
  border: 1px solid #d7e0e2;
  border-radius: 10px;
  background: #f5f8f8;
  color: #31515a;
  text-align: center;
  font-size: 13px;
`;

const Retry = styled.button`
  border: 1px solid #03660c;
  border-radius: 7px;
  background: #fff;
  color: #03660c;
  padding: 7px 12px;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
`;

export default function GoogleMapBoundary({ children, height = "300px" }) {
  const { isLoaded, isLoading, error, retry } = useGoogleMaps();

  if (isLoaded) return children;

  return (
    <Fallback $height={height} role={error ? "alert" : "status"} aria-live="polite">
      <span>
        {error
          ? "The map service is temporarily unavailable. A valid saved location can still be used."
          : "Loading the map…"}
      </span>
      {error && (
        <Retry type="button" onClick={retry}>
          Retry map
        </Retry>
      )}
      {isLoading && <span aria-hidden="true">•••</span>}
    </Fallback>
  );
}

GoogleMapBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  height: PropTypes.string,
};
